import qs from 'qs';
import textMetrics from 'text-metrics';

import fontsLoaded from '~/fonts';
import { addToBasket } from '~/common';
import { formatPrice } from '~common/index';
import $ from '~/qwery';
import bean from '~/bean';
import axios from '~/axios';
import Button from '~/components/button';
import LinkButton from '~/components/link-button';
import Form from '~/components/form';
import RadioGroup from '~/components/radio-group';
import BasketPopup from '~/components/popup/basket-popup';

if (document.querySelector('.b-page.order-page')) {
    const $orderPage = $('.b-page.order-page');
    const $orderForm = $('.order-form', $orderPage);
    const $centerSubpagesTable = $('.center-subpages-table', $orderPage);
    const $subpagesToBeCentered = $('.subpage', $centerSubpagesTable);
    const $contactsFieldBlock = $('.contacts-field-block', $orderPage);
    const $deliverySubpage = $('.delivery-subpage', $orderPage);
    const $scopePills = $('.scope-pills', $orderPage);
    const $deliveryRadioGroupsDict = $('.delivery-radio-group', $orderPage)
        .toArray()
        .reduce(
            (r, el) => Object.assign(r, {
                [$(el).data('scope')]: $(el),
            }),
            {}
        );
    const $buttons = $('.buttons', $orderPage);
    const $nextButton = $('.next-button', $orderPage);
    const $changeOrderLinkButton = $('.change-order-link-button', $orderPage);
    const $basketContentsWrapper = $('.basket-contents-wrapper', $orderPage);
    let $basePriceRow, $basePrice, $discountRow, $discount,
        $deliveryRow, $deliveryFee, $total;
    updateTotalVars();

    const orderForm = new Form($orderForm);
    const deliveryRadioGroupsDict = Object.keys($deliveryRadioGroupsDict).reduce(
        (r, scope) => Object.assign(r, {
            [scope]: new RadioGroup($deliveryRadioGroupsDict[scope]),
        }),
        {}
    );
    const nextButton = new Button($nextButton);
    const changeOrderLinkButton = new LinkButton($changeOrderLinkButton);

    const scopes = Object.keys($deliveryRadioGroupsDict);
    let scope = $('.current', $scopePills).data('value');
    let basePrice = $basePrice.data('value');
    let discount = $discount.data('value');
    let deliveryFee = 0;
    const deliveryTypeMap = JSON.parse($orderPage.data('delivery-types')).reduce(
        (r, i) => Object.assign(r, {[i['name']]: i['fee']})
    , {});
    let deliveryRadioGroupFieldsFixed = {};

    fontsLoaded.then(() => {
        $centerSubpagesTable[0].style.minWidth
            = $centerSubpagesTable[0].offsetWidth + 'px';
        $subpagesToBeCentered.each(sp => $(sp).removeClass('invisible'));
        $buttons.removeClass('invisible');
    });

    function fixDeliveryRadioGroupFields() {
        if (deliveryRadioGroupFieldsFixed[scope])
            return;

        // indent field blocks
        const $fieldBlocks = $('.field-block', $deliveryRadioGroupsDict[scope]);
        const extraSpace = 5;
        $fieldBlocks.each(fw => {
            const $fw = $(fw);
            const $nameCells = $('td:first-child', $fw);

            // leave room for getting bold
            $nameCells[0].style.width = $nameCells[0].offsetWidth
                - parseFloat($nameCells.css('padding-right'))
                + extraSpace + 'px';

            const nLines = $nameCells.map(
                nc => textMetrics(nc).lines(nc.innerText).length
            ).reduce((r, i) => r + i, 0);

            if (nLines == 1) {
                $fw[0].style.marginLeft = parseFloat($fw.css('margin-left'))
                    - extraSpace + 'px';
                return;
            }

            const lineWidths = [].concat.apply([],
                $nameCells.map(nc => {
                    const nctm = textMetrics(nc);
                    return nctm.lines(nc.innerText).map(l => nctm.width(l));
                }));
            const diff = Math.max.apply(Math, lineWidths) - lineWidths[0];
            $fw[0].style.marginLeft = parseFloat($fw.css('margin-left'))
                - extraSpace
                - diff + 'px';
        });

        // amend field width
        const $fields = $('input', $deliveryRadioGroupsDict[scope]);
        if ($fields.length > 1) {
            const $first = $fields.first();
            const $rest = $($fields.toArray().filter(f => {
                return f != $first[0]
                    && ! ['branch-nova-poshta', 'branch-nova-poshta-kyiv'].includes(f.name);
            }));
            const firstRect = $first[0].getBoundingClientRect();
            $rest.each(f => {
                const rect = f.getBoundingClientRect();
                const diff = firstRect.right - rect.right;
                f.style.width = parseFloat($(f).css('width'))
                    + diff + 'px';
            });
        }

        if (scope == 'kyiv') {
            // leave room for getting bold
            const $fieldLabelCellAddress = $('.field-label-cell-address', $orderForm)
            $fieldLabelCellAddress.css(
                'width', $fieldLabelCellAddress[0].offsetWidth + extraSpace + 'px');
            $fieldLabelCellAddress.parent('table').css(
                'margin-left', -extraSpace + 'px');
        }

        deliveryRadioGroupFieldsFixed[scope] = true;
    }

    function isSuccessfulControl(n) {
        switch (n) {
        case 'town-nova-poshta':
            return deliveryRadioGroupsDict[scope].value() == 'nova-poshta';
        case 'branch-nova-poshta':
            return deliveryRadioGroupsDict[scope].value() == 'nova-poshta';
        case 'branch-nova-poshta-kyiv':
            return deliveryRadioGroupsDict[scope].value() == 'nova-poshta-kyiv';
        case 'address-ukrposhta-ukraine':
            return deliveryRadioGroupsDict[scope].value() == 'ukrposhta-ukraine';
        case 'address-ukrposhta-world':
            return deliveryRadioGroupsDict[scope].value() == 'ukrposhta-world';
        case 'address':
            return ! [
                'self-collection', 'nova-poshta', 'ukrposhta-ukraine', 'ukrposhta-world',
            ].includes(deliveryRadioGroupsDict[scope].value());
        default:
            const hiddenRGs = scopes.filter(s => s != scope)
                .map(s => 'delivery_type-' + s);
            return ! hiddenRGs.includes(n);
        }
    }

    function updateTotalVars() {
        $basePriceRow = $('.base-price-row', $orderPage);
        $basePrice = $('.base-price', $orderPage);
        $discountRow = $('.discount-row', $orderPage);
        $discount = $('.discount', $orderPage);
        $deliveryRow = $('.delivery-row', $orderPage);
        $deliveryFee = $('.delivery-fee', $orderPage);
        $total = $('.total', $orderPage);
    }

    function updateTotals() {
        $basePriceRow[
            discount || deliveryFee ? 'removeClass' : 'addClass'
        ]('hidden');
        $basePrice.text(formatPrice(basePrice));
        $discountRow[discount ? 'removeClass' : 'addClass']('hidden');
        $discount.text(formatPrice( - discount));
        $deliveryRow[deliveryFee ? 'removeClass' : 'addClass']('hidden');
        $deliveryFee.text(formatPrice(deliveryFee));
        $total.text(formatPrice(
            basePrice - discount + deliveryFee
        ));
    }

    bean.on($scopePills[0], 'click', 'li', e => {
        const $li = $(e.target).selfOrParent('li');
        if ($li.hasClass('current'))
            return;
        $('li', $scopePills).each(p => {
            const $p = $(p);
            $p[p == $li[0] ? 'addClass' : 'removeClass']('current');
        });
        scope = $li.data('value');
        Object.keys($deliveryRadioGroupsDict).forEach(s => {
            $deliveryRadioGroupsDict[s][
                s == scope ? 'removeClass' : 'addClass'
            ]('hidden');
        });
        scopes.forEach(s => {
            $deliverySubpage[s == scope ? 'addClass' : 'removeClass']('scope-' + s);
        });
        deliveryRadioGroupsDict[scope].focus();
        fixDeliveryRadioGroupFields();
    });

    bean.on($deliverySubpage[0], 'click', '.b-radio-group input', e => {
        deliveryRadioGroupsDict[scope].checkRadioButton(
            deliveryRadioGroupsDict[scope].radioButtonByElement(e.target),
            false);
    });

    bean.on($deliverySubpage[0], 'change', '.b-radio-group', e => {
        const v = deliveryRadioGroupsDict[scope].value();
        deliveryFee = deliveryTypeMap[v];
        updateTotals();
    });

    bean.on($nextButton[0], 'press', e => {
        if ($orderPage.hasClass('contacts-subpage')) {
            if ( ! orderForm.validate())
                return;
            $orderPage.removeClass('contacts-subpage');
            $orderPage.addClass('delivery-subpage');
            deliveryRadioGroupsDict[scope].focus()
            fixDeliveryRadioGroupFields();
        } else {
            if (nextButton.disabled())
                return;
            if ( ! orderForm.validate(f => isSuccessfulControl(f.name)))
                return;
            nextButton.disabled(true);
            let data = orderForm.getData();
            data = Object.keys(data)
                .filter(k => isSuccessfulControl(k))
                .reduce((r, k) => {
                    const map = Object.assign(
                        scopes.reduce((r, s) => Object.assign(r, {
                            ['delivery_type-' + s]: 'delivery_type',
                        }), {}),
                        {'town-nova-poshta': 'town',
                        'branch-nova-poshta': 'branch',
                        'branch-nova-poshta-kyiv': 'branch',
                        'address-ukrposhta-ukraine': 'address',
                        'address-ukrposhta-world': 'address'});
                    const k2 = map[k] || k;
                    return Object.assign(r, {[k2]: data[k]});
                }, {});
            axios.post('/order', qs.stringify(data)).then(resp => {
                $orderPage.removeClass('delivery-subpage');
                $orderPage.addClass('thanks-subpage');
                $buttons.addClass('hidden');
                $changeOrderLinkButton.addClass('hidden');
                nextButton.disabled(false);
            });
        }
    });

    bean.on($changeOrderLinkButton[0], 'press', () => {
        if (changeOrderLinkButton.disabled())
            return;
        changeOrderLinkButton.disabled(true);
        addToBasket().then(resp => {
            const popup = new BasketPopup(resp.data, {
                deliveryFee,
                noCancelButton: true,
                okButton: {
                    role: 'button',
                    label: 'Закрити',
                },
                onChange: (data, newTotals) => {
                    basePrice = newTotals['basePrice'];
                    discount = newTotals['discount'];
                    $basketContentsWrapper.html(data.html);   // obsoletes some DOM vars
                    updateTotalVars();
                    updateTotals();
                    $('.b-basket-contents', $basketContentsWrapper)
                        .removeClass('editable');
                    if ( ! data.items.length)
                        location = '/';
                },
                onDestroy: () => {
                    changeOrderLinkButton.disabled(false);
                    $changeOrderLinkButton[0].focus();
                },
            });
        });
    });
}



// WEBPACK FOOTER //
// ./makosh/assets/pages/order.js